import { AccountNotFoundError, } from "@alchemy/aa-core";
import { SessionKeyPlugin, sessionKeyPluginActions as sessionKeyPluginActions_, } from "./plugin.js";
import { buildSessionKeysToRemoveStruct } from "./utils.js";
export const sessionKeyPluginActions = (client) => {
    const { removeSessionKey, addSessionKey, rotateSessionKey, updateKeyPermissions, ...og } = sessionKeyPluginActions_(client);
    return {
        ...og,
        isAccountSessionKey: async ({ key, pluginAddress, account = client.account, }) => {
            if (!account)
                throw new AccountNotFoundError();
            const contract = SessionKeyPlugin.getContract(client, pluginAddress);
            return await contract.read.isSessionKeyOf([account.address, key]);
        },
        getAccountSessionKeys: async (args) => {
            const account = args?.account ?? client.account;
            if (!account)
                throw new AccountNotFoundError();
            const contract = SessionKeyPlugin.getContract(client, args?.pluginAddress);
            return await contract.read.sessionKeysOf([account.address]);
        },
        removeSessionKey: async ({ key, overrides, account = client.account, pluginAddress, }) => {
            if (!account)
                throw new AccountNotFoundError();
            const sessionKeysToRemove = await buildSessionKeysToRemoveStruct(client, {
                keys: [key],
                account,
                pluginAddress,
            });
            return removeSessionKey({
                args: [key, sessionKeysToRemove[0].predecessor],
                overrides: overrides,
                account,
            });
        },
        addSessionKey: async ({ key, tag, permissions, overrides, pluginAddress, account = client.account, }) => {
            if (!account)
                throw new AccountNotFoundError();
            return addSessionKey({
                args: [key, tag, permissions],
                overrides: overrides,
                account,
                pluginAddress,
            });
        },
        rotateSessionKey: async ({ newKey, oldKey, overrides, pluginAddress, account = client.account, }) => {
            if (!account)
                throw new AccountNotFoundError();
            const contract = SessionKeyPlugin.getContract(client, pluginAddress);
            const predecessor = await contract.read.findPredecessor([
                account.address,
                oldKey,
            ]);
            return rotateSessionKey({
                args: [oldKey, predecessor, newKey],
                overrides: overrides,
                account,
                pluginAddress,
            });
        },
        updateSessionKeyPermissions: async ({ key, permissions, overrides, pluginAddress, account = client.account, }) => {
            if (!account)
                throw new AccountNotFoundError();
            return updateKeyPermissions({
                args: [key, permissions],
                overrides: overrides,
                account,
                pluginAddress,
            });
        },
    };
};
//# sourceMappingURL=extension.js.map